import * as React from 'react'

import {
  i18n,
  useSiteConfig,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'
import { SwatchShape } from '@thg-commerce/gravity-elements/Swatch/types'
import { SelectedOptions } from '@thg-commerce/gravity-patterns'
import { SimpleProductOptions as GravityProductOptions } from '@thg-commerce/gravity-patterns/ProductOptions/SimpleProductOptions'

import { TransformedOption as Option } from '../transformers/option'

export interface ProductOptionSelectorProps {
  options: Option[]
  onOptionChange: (optionKey: string, value: string) => void
  onDropdownClick: () => void
  onColourSwatchClick: () => void
  onLinkedSkuOptionChange: (option: string) => void
  setDisplayError: (error: boolean) => void
  displayError: boolean
  preselectVariant: boolean
  forceDropDowns?: boolean
  swatchShape?: SwatchShape
  showSwatches?: boolean
  notifyWhenInStock?: boolean
  labelCustomComponent?: React.ReactNode
  isFirstProductRecommendation?: boolean
  selectedOptions?: SelectedOptions
  disableColorDropdown?: boolean
  showVariantNameNextTocolorLabel?: boolean
  enableFBTProductOptionPlacement?: boolean
  choiceMapLoading?: boolean
}

export const ProductOptions = (props: ProductOptionSelectorProps) => {
  const theme = useTheme()
  const {
    showAllImageSwatches,
    hasShoeSizeMeId,
    showBrandNameBeforeSize,
    hideAsterixOnPDP,
    enableOOSAddtoWishlist,
  } = useSiteConfig()
  const siteDefinition = useSiteDefinition()
  const brandName = siteDefinition?.brand

  // TODO REBUILD-8933 remove i18n
  const i18nText = {
    missingSizeError: i18n('product.missing.size.error'),
    swatch: {
      unavailableText: i18n('product.productoptions.dropdown.unavailable.text'),
      closeButtonText: i18n('product.productoptions.swatch.tooltip.close.text'),
      showMoreButtonText: i18n(
        'product.productoptions.swatch.button.more.text',
      ),
      showLessButtonText: i18n(
        'product.productoptions.swatch.button.less.text',
      ),
    },
    imageSwatch: {
      showButtonText: i18n(
        'product.productoptions.imageswatch.button.show.text',
      ),
      showMoreButtonText: i18n(
        'product.productoptions.imageswatch.button.more.text',
      ),
      showLessButtonText: i18n(
        'product.productoptions.imageswatch.button.less.text',
      ),
    },
    dropdown: {
      unavailableText: i18n('product.productoptions.dropdown.unavailable.text'),
      customLabelText: i18n('product.productoptions.dropdown.customlabel.text'),
    },
    wishlist: {
      unavailableText: i18n('account.wishlist.option.unavailable.text'),
    },
  }

  return (
    <GravityProductOptions
      options={props.options || []}
      onOptionChange={(option, optionValue) => {
        props.onOptionChange(option, optionValue)
        props.onLinkedSkuOptionChange(option)
      }}
      selectedOptions={props.selectedOptions}
      i18nText={i18nText}
      labelCustomComponent={props.labelCustomComponent}
      forceDropDowns={props.forceDropDowns}
      swatchShape={props.swatchShape}
      onColourSwatchClick={props.onColourSwatchClick}
      onDropdownClick={props.onDropdownClick}
      required={false}
      swatch={{
        show: props.showSwatches
          ? props.showSwatches
          : theme.pageTheme?.productOptions.swatch?.show ?? true,
      }}
      notifyWhenInStockInDropdown={props.notifyWhenInStock}
      dropdownWidth={
        theme?.pageTheme?.productOptions?.addToBasketContainer?.fullWidth
          ? '100%'
          : ''
      }
      maxDropdownHeight="300px"
      customErrorMessage={{
        displayError: !props.preselectVariant && props.displayError,
        errorMessage: i18nText.missingSizeError,
      }}
      showAllImageSwatches={showAllImageSwatches}
      disableColorDropdown={props.disableColorDropdown}
      boxClassName={!!hasShoeSizeMeId ? 'athenaProductVariations_listItem' : ''}
      showBrandNameBeforeSize={showBrandNameBeforeSize}
      brandName={brandName}
      hideAsterixOnPDP={hideAsterixOnPDP}
      showVariantNameNextTocolorLabel={props.showVariantNameNextTocolorLabel}
      enableOOSAddtoWishlist={enableOOSAddtoWishlist}
      enableFBTProductOptionPlacement={props.enableFBTProductOptionPlacement}
      noSkeletonLoading={props.choiceMapLoading}
    />
  )
}
